import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-screen-mid-list-4",
  "use": "icon-screen-mid-list-4-usage",
  "viewBox": "0 0 33.525 33.525",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33.525 33.525\" id=\"icon-screen-mid-list-4\"><defs><style>#icon-screen-mid-list-4 .a{fill:#48ffff;}</style></defs><path class=\"a\" d=\"M80.762,68A16.762,16.762,0,1,0,97.525,84.762,16.764,16.764,0,0,0,80.762,68Zm6.993,17.567a1.408,1.408,0,0,1-1.4,1.4h-6.54a1.4,1.4,0,0,1-1.377-1.145,1.421,1.421,0,0,1-.064-.419V76.512a1.408,1.408,0,0,1,1.4-1.4h.21a1.408,1.408,0,0,1,1.4,1.4v7.442h4.969a1.408,1.408,0,0,1,1.4,1.4v.21Z\" transform=\"translate(-64 -68)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol